import { io } from 'socket.io-client';

// Configurar conexão Socket.IO
const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || '/';

// Criar instância do socket
export const socket = io(SOCKET_URL, {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  timeout: 10000,
  transports: ['websocket', 'polling']
});

// Eventos de conexão
socket.on('connect', () => {
  // Registrar usuário como online se já estiver logado
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      socket.emit('user_login', user);
    } catch (error) {
      console.error('Erro ao registrar usuário:', error);
    }
  }
});

socket.on('disconnect', (reason) => {
  // Desconectado do servidor
});

socket.on('connect_error', (error) => {
  console.error('Erro de conexão:', error.message);
});

socket.on('reconnect', (attemptNumber) => {
  // Re-registrar usuário como online após reconexão
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      socket.emit('user_login', user);
    } catch (error) {
      console.error('Erro ao re-registrar usuário:', error);
    }
  }
});

socket.on('reconnect_error', (error) => {
  console.error('Erro ao reconectar:', error.message);
});

socket.on('reconnect_failed', () => {
  console.error('Falha ao reconectar');
});

export default socket;
